<script setup>
import { computed } from 'vue'
import { useQuasar } from 'quasar'
import useAuth from '../../store/auth.store'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const auth = useAuth()
const $q = useQuasar()

defineProps({
  isDrawerOpen: {
    type: Boolean,
    default: true
  }
})

defineEmits(['update:isDrawerOpen'])

const menus = [
  { id: 'map', name: 'map', icon: 'map', identifier: 'ADDRESSES' },
  { id: 'dashboard', name: 'board-monitor', icon: 'trending_up', identifier: 'DASHBOARD' },
  { id: 'addresses', name: 'board-address', icon: 'maps_home_work', identifier: 'ADDRESSES' },
  { id: 'devices', name: 'board-device', icon: 'devices', identifier: 'DEVICES' },
  { id: 'customers', name: 'board-customer', icon: 'group', identifier: 'CUSTOMERS' },
]

const systemMenus = [
  { id: 'users', name: 'board-users', icon: 'segment', identifier: 'USERS' },
  { id: 'roles', name: 'board-roles', icon: 'volunteer_activism', identifier: 'ROLES' },
  { id: 'logs', name: 'board-logs', icon: 'select_all', identifier: 'LOGS' },
  { id: 'settings', name: 'board-settings', icon: 'settings', identifier: 'SETTINGS' }
]

const allowedMenus = computed(() => menus.filter(item => auth.allowedMenus.value.includes(item.identifier)))
const allowedSystemMenus = computed(() => systemMenus.filter(item => auth.allowedMenus.value.includes(item.identifier)))
</script>

<template lang='pug'>
.main-menu
  q-drawer.overflow-hidden(
    :model-value="isDrawerOpen"
    @update:model-value="$emit('update:isDrawerOpen', $event)"
    show-if-above
    side='left'
    bordered
    :width='240'
  )
    q-scroll-area(style="height: calc(100%); ")
      q-list
        q-item(
          v-for='menu in allowedMenus'
          :key='menu.id'
          :active='$route.matched.some(item => item.name === menu.name)'
          :active-class=`$q.dark.isActive ? 'text-primary bg-accent border-left-primary' : 'text-primary bg-grey-3 border-left-primary'`
          :to='{ name: menu.name }'
        )
          q-item-section.q-pl-sm(avatar)
            q-icon(:name='menu.icon')
          q-item-section
            .text-weight-bold.text-no-wrap {{ t(`menu.${menu.id}`) }}
        .drawer-footer.overflow-hidden(:class=`$q.dark.isActive ? 'border-top-dark' : 'border-top-light'`)
        q-item
          q-item-section.q-pl-sm
            .text-weight-bold.text-no-wrap
              div.text-bold {{ t("menu.system") }}

        q-item(
          v-for='menu in allowedSystemMenus'
          :key='menu.id'
          :active='$route.matched.some(item => item.name === menu.name)'
          :active-class=`$q.dark.isActive ? 'text-primary bg-accent border-left-primary' : 'text-primary bg-grey-3 border-left-primary'`
          :to='{ name: menu.name }'
        )
          q-item-section.q-pl-sm(avatar)
            q-icon(:name='menu.icon')
          q-item-section
            .text-weight-bold.text-no-wrap {{ t(`menu.${menu.id}`) }}
</template>
